import { render, staticRenderFns } from "./WPXForm.vue?vue&type=template&id=6a48ccd4&"
import script from "./WPXForm.vue?vue&type=script&lang=ts&"
export * from "./WPXForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports